<template>
    <div v-if="mode==='tiles'"
         class="file-box"
         @click.self="$emit('tapped')"
         @mouseover="hover = true"
         @mouseleave="hover = false"
    >
        <i class="fa-thin fa-chevron-right fa-2x arrow" @click.self="$emit('tapped')"/>

        <v-card :class="value===index ? 'active file campaign-element' : 'file campaign-element'"
                :width="Math.max(computedMaxWidth, previewFrame.width)"
                @click.native="tapWrapper()"
        >
            <v-card-title class="preview-item preview"
                          :style="{width: previewFrame.width + 'px', height: previewFrame.height + 'px'}"
            >
                <component v-if="data.type"
                           :is="data.type + 'Element'"
                           :data="data"
                           :frame="previewFrame"
                           :info-styles="infoStyles"
                           :basic-content-styles="basicContentStyles"
                           :width="previewFrame.width"
                           :height="previewFrame.height"
                />
            </v-card-title>
            <v-card-text>
                <div class="file-name card-file-name">
                    <element-trigger-icon v-if="interactive" invertColors :trigger="inner_element.trigger" />
                    <elementIcon :data="inner_element"/>
                    <div class="text-truncate">
                        {{ t_title }}
                    </div>
                </div>
                <validity-display
                    :id="data.id"
                    :element="inner_element"
                    :duration="duration()"
                />
            </v-card-text>
            <div class="actions overlay" v-if="hover || index === value">
                <div v-if="(inner_element.type === 'campaign' || inner_element.type === 'template') && mustConvert === false"
                     class="inline-block action">
                    <v-btn small class="edit inline-block"
                           :disabled="saving"
                           @click="updateCampaignAndRedirect()">
                        <i class="fa-regular fa-pencil" aria-hidden="true" :title="t_edit"></i>
                    </v-btn>
                    <v-btn small v-if="!inner_element.inline && inner_element.state === 'link'"
                           class="copy inline-block"
                           :disabled="saving"
                           @click="convertLink()">
                        <i class="fa-regular fa-link-simple-slash" aria-hidden="true" :title="t_local_copy"></i>
                    </v-btn>
                </div>
                <v-btn :aria-label="t_copy" small class="copy inline-block action" v-if="!dynamic"
                       :disabled="saving"
                       @click="copyElement">
                    <i class="fa-regular fa-clone" aria-hidden="true" :title="t_copy"></i>
                </v-btn>
                <v-btn :aria-label="t_delete" small class="delete inline-block action" v-if="!dynamic"
                       :disabled="saving"
                       @click="removeElement">
                    <i class="fa-regular fa-trash" aria-hidden="true" :title="t_delete"></i>
                </v-btn>
            </div>
        </v-card>
    </div>
    <v-row v-else class="list-box layer-row campaign-element" :class="value===index ? 'active' : ''" @click="tapWrapper()" :data-id="inner_element.id"
           @mouseover="hover = true"
           @mouseleave="hover = false">
        <v-col cols="12">
            <v-card flat>
                <v-card-text :class="size">
                    <v-row>
                        <element-trigger-column v-if="interactive" :trigger="inner_element.trigger" :id="inner_element.id" />
                        <v-col :cols="previewCols"
                               class="preview-col"
                               @click="showMedia(inner_element)">
                            <div :style="{
                                    height: Math.min(previewFrame.height) + 'px',
                                    width: Math.min(previewFrame.width) + 'px',
                                    maxHeight: Math.min(previewFrame.height) + 'px',
                                    maxWidth: Math.min(previewFrame.width) + 'px',
                                    minHeight: Math.min(previewFrame.height) + 'px',
                                    minWidth: Math.min(previewFrame.width) + 'px',
                                 }"
                                 class="rounded preview"
                                 :class="{'preview-available': canShowMedia(inner_element)}">
                                <component v-if="inner_element.type!==''"
                                           :is="inner_element.type + 'Element'"
                                           :index="index"
                                           :data="inner_element"
                                           :description="null"
                                           :frame="previewFrame"
                                           :info-styles="infoStyles"
                                           :basic-content-styles="basicContentStyles"
                                           :width="Math.min(computedMaxWidth)"
                                           :height="Math.min(computedMaxHeight)">
                                </component>
                            </div>
                        </v-col>
                        <v-col :cols="11 - previewCols">
                            <v-card-title :class="[value===index ? 'primary--text' : '', size]" ref="card-title">
                                <div class="icon-container m-r-xs">
                                    <elementIcon :data="inner_element" :active="value===index" :size="size"/>
                                </div>
                                <span v-text="elementName"></span>
                            </v-card-title>
                            <v-row class="details">
                                <v-col :cols="detailsCols">
                                    <div v-if="inner_element.readonly" v-text="t_readonly" class="orange--text"></div>
                                    <div>{{ elementDescription }}</div>
                                    <validity-display
                                        :id="data.id"
                                        :element="inner_element"
                                        colorOnlyText
                                        disableTooltip
                                        :duration="duration()"
                                    />
                                </v-col>
                                <v-col v-if="actionsCols > 0" :cols="actionsCols" class="actions">
                                    <div class="pull-right"
                                         style="display: flex; justify-content: end; gap: 4px; flex-wrap: wrap;">
                                        <template v-if="saving === true">
                                            <strong class="text-danger">{{ t_wait }}</strong>
                                        </template>
                                        <template v-else>
                                            <div v-if="(inner_element.type === 'campaign' || inner_element.type === 'template') && mustConvert === false"
                                                 class="inline-block">
                                                <v-btn small class="edit inline-block"
                                                        @click="updateCampaignAndRedirect()">
                                                    <i class="fa-regular fa-pencil" aria-hidden="true" :title="t_edit"></i>
                                                </v-btn>
                                                <v-btn small v-if="!inner_element.inline && inner_element.state === 'link'"
                                                        class="copy inline-block"
                                                        @click="convertLink()">
                                                    <i class="fa-regular fa-link-simple-slash" aria-hidden="true" :title="t_local_copy"></i>
                                                </v-btn>
                                            </div>
                                            <v-btn small class="copy inline-block" v-if="!dynamic"
                                                    @click="copyElement">
                                                <i class="fa-regular fa-clone" aria-hidden="true" :title="t_copy"></i>
                                            </v-btn>
                                            <v-btn small class="delete inline-block" v-if="!dynamic"
                                                    @click="removeElement">
                                                <i class="fa-regular fa-trash" aria-hidden="true" :title="t_delete"></i>
                                            </v-btn>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <template v-if="inner_element.readonly !== true">
                    <div class="element-move-dots" style="top:calc(50% - 14px);">
                        <div class="element-move-dot" style="top:6px;"></div>
                        <div class="element-move-dot" style="top:14px;"></div>
                        <div class="element-move-dot" style="top:22px;"></div>
                    </div>
                </template>
            </v-card>
            <v-divider></v-divider>
        </v-col>
    </v-row>
</template>

<script>
import bootstrapElement from './_bootstrapElement';
import elementTypes from "../elements/types";

import textElement from '../elements/text.vue';
import rssfeedElement from '../elements/rssfeed.vue';
import iframeElement from '../elements/iframe.vue';
import youtubeElement from '../elements/youtube.vue';
import qrcodeElement from '../elements/qrcode.vue';
import countdownElement from '../elements/countdown.vue';
import pictureElement from '../elements/picture.vue';
import videoElement from '../elements/video.vue';
import pdfElement from '../elements/pdf.vue';
import pptElement from '../elements/ppt.vue';
import emptyrectangleElement from '../elements/emptyrectangle.vue';
import templateElement from '../elements/template.vue';
import campaignElement from '../elements/campaign.vue';
import clockElement from '../elements/clock.vue';
import dayElement from '../elements/day.vue';
import weatherElement from '../elements/weather.vue';
import layerElement from '../elements/layer.vue';
import esignElement from '../elements/esign.vue';
import streamingElement from '../elements/streaming.vue';
import widgetElement from "../elements/widget";
import elementIcon from "../elements/element-icon";
import ValidityDisplay from "./validity-display.vue";
import {
    calcElementDuration,
    getDurationRunsDisplayText,
    getDescriptionForElement
} from '../../../../utils/publish';
import ElementTriggerColumn from "../elements/element-trigger-column.vue";
import ElementTriggerIcon from "../elements/element-trigger-icon.vue";

export default {
        props: [
            'data',
            'value',
            'index',
            'parameters',
            'is_disabled',
            'saving',
            'grid',
            'size',
            'mode',
            'mustConvert',
            'dynamic',
            'interactive',
            'layoutInfo',
            'windowInfo',
            'default_duration',
            'allLayers'
        ],
        mixins: [bootstrapElement],
        components: {
            ElementTriggerIcon,
            ElementTriggerColumn,
            ValidityDisplay,
            textElement,
            rssfeedElement,
            iframeElement,
            youtubeElement,
            qrcodeElement,
            countdownElement,
            pictureElement,
            videoElement,
            pdfElement,
            pptElement,
            emptyrectangleElement,
            templateElement,
            campaignElement,
            clockElement,
            dayElement,
            weatherElement,
            layerElement,
            esignElement,
            streamingElement,
            widgetElement,
            elementIcon,
        },
        data: function() {
            return {
                t_copy: Lang.langGet("Create copy"),
                t_local_copy: Lang.langGet("Create Local Copy"),
                t_edit: Lang.langGet("Edit"),
                t_delete: Lang.langGet("Delete"),
                t_edit_settings: Lang.langGet("Edit Element Settings"),
                t_wait: Lang.langGet("Please wait..."),
                t_display_runs: Lang.langGet("Runs"),
                t_readonly: Lang.langGet("READ ONLY"),
                inner_element: {
                    id: null,
                    name: "",
                    type: "",
                    duration: 0,
                    duration_original: undefined,
                    duration_type: 1,
                    background_image: '',
                },

                width: 0,
                height: 0,
                previewFrame: {
                    width: 1,
                    height: 1,
                    ratio: 1,
                },
                hover: false,
            }
        },
        computed: {
            previewCols () {
                if (this.size === 'small') {
                    if (this.grid ==='2cols') {
                        return 1;
                    } else {
                        return 2;
                    }
                } else if (this.size === 'medium') {
                    if (this.grid === '2cols') {
                        return 2;
                    } else {
                        return 3;
                    }
                } else {
                    if (this.grid ==='2cols') {
                        return 3;
                    } else {
                        return 4;
                    }
                }
            },
            detailsCols () {
                if (this.value !== this.index && this.hover === false) {
                    return 12;
                }
                if (this.size === 'small') {
                    if (this.grid ==='2cols') {
                        return 10;
                    } else {
                        return 9;
                    }
                } else {
                    if (this.grid ==='2cols') {
                        return 10;
                    } else {
                        return 9;
                    }
                }
            },
            actionsCols () {
                if (this.value !== this.index && this.hover === false) {
                    return 0;
                }
                if (this.size === 'small') {
                    if (this.grid ==='2cols') {
                        return 2;
                    } else {
                        return 3;
                    }
                } else {
                    if (this.grid ==='2cols') {
                        return 2;
                    } else {
                        return 3;
                    }
                }
            },
            elementName: function () {
                if (this.inner_element.name) {
                    return this.inner_element.name;
                }
                let type = this.inner_element.type;
                let desc = this.elementDescription;
                desc = (desc !== '') ? ' - ' + desc : '';
                if (type !== '') {
                    if (type === 'campaign' && element.dynamic) {
                        type = Lang.langGet("Dynamic Campaign");
                    } else {
                        type = Lang.langGet(elementTypes.titles[type]);
                    }
                }
                return type + desc;
            },
            numCols: function () {
                if (this.grid === '2cols') {
                    return 8;
                } else if (this.grid === '3cols') {
                    return 5;
                } else {
                    return 12;
                }
            },
            computedMaxWidth: function () {
                if (this.windowInfo !== null && this.windowInfo !== undefined && this.layoutInfo !== null && this.layoutInfo !== undefined) {
                    let width = ((this.windowInfo.colWidth * this.numCols) - this.layoutInfo.editorPadding) / 12;

                    width = width * this.previewCols;
                    if (this.size === 'small') {
                        width -= 12 + 4;
                    } else  if (this.size === 'medium') {
                        width -= 12 + 8;
                    } else {
                        width -= 24;
                    }
                    return width;
                } else {
                    return 120;
                }
            },
            computedMaxHeight: function () {
                return this.computedMaxWidth * this.height / this.width;
            },
            basicContentStyles: function () {
                var width = '100%';
                var height = width;
                var margin = this.markArea ? '-1px' : '';
                var clip = this.markArea ? 'rect(1px,calc(100% + 1px),calc(100% + 1px),1px)' : '';

                return {
                    //position: 'absolute',
                    clip: clip,
                    width: width,
                    height: height,
                    margin: margin,
                    position: 'relative',
                    overflow: 'hidden',
                }
            },
            infoStyles: function () {
                var left = 4;
                var bottom = 4;
                return {
                    left: left + 'px',
                    bottom: bottom + 'px',
                }
            },
            t_title: function () {
                let name = this.inner_element.name;
                if (name) {
                    return name;
                }

                let title = '';
                if(this.inner_element.type === 'campaign' && this.inner_element.dynamic) {
                    title = Lang.langGet("Dynamic Campaign");
                } else {
                    title = Lang.langGet(elementTypes.titles[this.inner_element.type]);
                }

                title += ' - ' + this.elementDescription;

                return title;
            },
            elementDescription() {
                const elementWithLayers = {...this.inner_element, all_layers: this.allLayers};
                return getDescriptionForElement(elementWithLayers);
            },
        },
        watch: {
            data: {
                handler() {
                    this.inner_element = this.data;
                },
                deep: true
            },
            mode() {
                this.calculatePreviewFrame();
            },
            size() {
                this.calculatePreviewFrame();
            }
        },
        methods: {
            getCampaignSize: function () {
                let width = 0;
                let height = 0;
                let resolution = this.parameters.resolution.split('x');
                width = resolution[0];
                height = resolution[1];

                this.height = height;
                this.width = width;

                return {
                    width: width,
                    height: height
                }
            },
            calculatePreviewFrame: function () {
                const campaignSize = this.getCampaignSize();

                const maxWidth = (this.mode === 'list') ? this.computedMaxWidth : 196 ;
                const maxHeight = (this.mode === 'list') ? (maxWidth * 9/16) : 148;


                const ratio = campaignSize.height / campaignSize.width;

                let thumbWidth = maxWidth;
                let thumbHeight = maxWidth * ratio;

                if (thumbHeight > maxHeight) {
                    thumbWidth = maxHeight / ratio;
                    thumbHeight = maxHeight;
                }

                this.previewFrame = {
                    width: thumbWidth,
                    height: thumbHeight,
                    ratio: thumbWidth/campaignSize.width,
                }
            },
            calculateElementSize(elementRef, stretch, imageSrc, mediaName, type) {
                let size = '100% 100%';

                if (stretch === 'original') {
                    var media = new Image();

                    if (type === 'video') {
                        media = document.createElement('video');
                    }

                    if (imageSrc.indexOf('thumb/') >= 0) {
                        media.src = imageSrc.replace(imageSrc.substr(imageSrc.indexOf('thumb/')), mediaName);
                    } else {
                        media.src = imageSrc.replace(imageSrc.substr(imageSrc.lastIndexOf('/') + 1), mediaName);
                    }

                    if (type === 'video') {
                        media.load();
                    }

                    media.onload = () => {
                        let imgWidth = media.width,
                            imgHeight = media.height;
                        let campaignSize = this.getCampaignSize();

                        let background_image_original_size = '';
                        background_image_original_size += imgWidth / campaignSize.width * 100 + "% ";
                        background_image_original_size += imgHeight / campaignSize.height * 100 + "%";
                        size = background_image_original_size;

                        this.$refs[elementRef].style.backgroundSize = size;
                    };
                    media.onerror = () => {
                        this.$refs[elementRef].style.backgroundSize = "100% 100%";
                    };

                    return '100% 100%';
                } else {
                    if (stretch === 'frame') {
                        size = '100% 100%';
                    } else if (stretch === 'aspect_fit') {
                        size = 'contain';
                    } else if (stretch === 'aspect_fill') {
                        size = 'cover';
                    }
                }
                return size;
            },
            removeElement: function () {
                if (this.saving === true) {
                    return;
                }
                EaseEventBus.fire('removeSelectedElement', this.index);
            },
            copyElement: function () {
                if (this.saving === true) {
                    return;
                }
                EaseEventBus.fire('copySelectedElement', this.index);
            },
            convertLink: function () {
                if (this.saving === true) {
                    return;
                }
                EaseEventBus.fire('convertLink', {'id': this.inner_element.id, 'type': this.inner_element.type, 'key': this.index});
            },
            updateCampaignAndRedirect: function() {
                if (this.saving === true) {
                    return;
                }
                EaseEventBus.fire('updateCampaignAndRedirect', {'id': this.inner_element.id, 'type': this.inner_element.type});
            },
            tapWrapper: function() {
                if(this.index !== -1) {
                    this.preventBackground = true;
                }
                if(this.value !== this.index && !(this.preventBackground && this.index === -1)) {
                    this.tap();
                    EaseEventBus.fire('settingsActive');
                }
            },
            duration: function () {
                const { duration, runs_text } = calcElementDuration(this.inner_element, this.default_duration);
                return getDurationRunsDisplayText(duration, runs_text);
            },
            parseTime: function (time) {
                if (!time) return {HH: '00', mm: '00'};

                if (_.isObject(time)) return time;

                if (_.isString(time)) {
                    const split = time.split(':');

                    if (split.length !== 2) return {HH: '00', mm: '00'};
                    else return {HH: split[0], mm: split[1]};
                }
            },
            canShowMedia(element) {
                return (element.type === 'widget' && element.index_html) || element.background_image
            },
            showMedia: function (element) {
                if (element.type === 'widget' && element.index_html) {
                    let url = element.index_html;

                    this.setActive();
                    this.$nextTick(() => {
                        EaseEventBus.fire('showMedia_WidgetAddQuery', {
                            mime_type: 'text/html',
                            original: url,
                            widget_id: element.id,
                            display_name: element.name,
                            previewFrame: _.extend({}, this.previewFrame)
                        });
                    })
                } else if (element.background_image) {
                    let url = '';
                    let mime = 'image/jpg';

                    if (element.type === 'video') {
                        mime = 'video/mp4';
                        url = element.background_image.replace('/thumb', '').replace('.jpg', '');
                    } else if (element.type === 'campaign') {
                        url = element.background_image.replace('/thumb', '/original');
                    } else if (element.type === 'widget') {
                        url = element.background_image;
                    } else {
                        url = element.background_image.replace('/thumb', '');
                    }

                    EaseEventBus.fire('showMedia', {
                        mime_type: mime,
                        original: url,
                        display_name: element.name
                    });
                }
            },
        },
        mounted: function() {
            this.inner_element = this.data;
            this.calculatePreviewFrame();
        }
    }
</script>

<style scoped>
    .file-box {
        cursor: grab;
    }
    .actions {
        .action {
            cursor: pointer;
        }
    }
    .file-name .eicon {
         display: inline-flex;
         align-items: center;
         justify-content: center;
         vertical-align: middle; /* optional */
         height: 1em;
         width: 1em;
    }
    .card-file-name {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
    }
</style>
